import { render, staticRenderFns } from "./ElRadioGroup.vue?vue&type=template&id=28a91476&scoped=true&"
import script from "./ElRadioGroup.vue?vue&type=script&lang=js&"
export * from "./ElRadioGroup.vue?vue&type=script&lang=js&"
import style0 from "./ElRadioGroup.vue?vue&type=style&index=0&id=28a91476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a91476",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio,VRadioGroup})
